import { Settings } from 'types';

import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getSettings } from '../';

export const useGetSettingsQuery = (
  queryOptions: UseQueryOptions<Settings, string[], Settings, QueryKey> = {
    queryKey: ['settings'],
  }
) => {
  return useQuery({
    queryFn: ({ signal }) => getSettings(signal),
    ...queryOptions,
  });
};
